import React from 'react';

import {
    Box, 
    Typography,
    Chip
} from '@mui/material';

import { grey } from '@mui/material/colors';

import { getEnvConfigs } from '../../configs/envConfigs'

export function SidebarLogo({ routeType, LogoComponent }){

    const {
        appVersion,
        appName
    } = getEnvConfigs()

    return (
        <Box sx={{ px: 2.5, py: 3, display: 'inline-flex', flexDirection: 'row', justifyContent: 'space-between', alignItems: 'flex-start' }}>
            {
                LogoComponent
            }
            <Box>
                <Chip 
                    // display={"block"}
                    color={"primary"}
                    sx={{
                        textTransform: 'capitalize'
                    }}
                    variant='outlined'
                    label={routeType}
                    size='small'
                />
                <Typography 
                    display={"block"}
                    sx={{
                        color: grey[500],
                        fontSize: 11,
                        textAlign: 'center'
                    }}
                >
                    v{appVersion}
                </Typography>
            </Box>
        </Box>
    )
}

